/**
 * ChartArrowFollowLesson (page)
 * -----------------------------
 * Minimal page wrapper that renders the shared HUD and a single lesson.
 * Also injects the global keyframes used by confetti/bull effects.
 */

// import React from "react";
// import ArrowUpLesson from "../lessons/ArrowUpLesson";
// import HeaderHUD from "../kit/HeaderHUD";
// import TrendLineLesson from "../lessons/TrendLineLesson";
// import HorizontalLineLesson from "../lessons/HorizontalLineLesson";

// const demoCandles = [
//   { time: "2024-06-01", open: 66000, high: 66750, low: 65500, close: 66500 },
//   { time: "2024-06-02", open: 66500, high: 67100, low: 66200, close: 66850 },
//   { time: "2024-06-03", open: 66850, high: 67200, low: 66400, close: 66500 },
//   { time: "2024-06-04", open: 66500, high: 66800, low: 65800, close: 66100 },
//   { time: "2024-06-05", open: 66100, high: 66500, low: 65700, close: 66350 },
//   { time: "2024-06-06", open: 66350, high: 67000, low: 66200, close: 66900 },
//   { time: "2024-06-07", open: 66900, high: 67500, low: 66650, close: 67300 },
//   { time: "2024-06-08", open: 67300, high: 67950, low: 67200, close: 67800 },
//   { time: "2024-06-09", open: 67800, high: 69000, low: 67600, close: 68950 },
// ];

// export default function ChartArrowFollowLesson({ onContinue }) {
//   return (
//     <div style={{ background: "#0B0D11", minHeight: "100vh", padding: 16 }}>
//       <HeaderHUD tokens={310} xp={190} />
//       {/* <ArrowUpLesson candles={demoCandles} onContinue={onContinue} /> */}

//       {/* <TrendLineLesson candles={demoCandles} onContinue={() => {}} /> */}
//      <HorizontalLineLesson candles={demoCandles} onContinue={() => {}} />

//       {/* global keyframes shared by effects */}
//       <style>{`
//         .confetti { position:absolute; width:10px; height:10px; border-radius:2px; opacity:.95; pointer-events:none; will-change: transform, opacity; animation: confetti-burst 900ms ease-out forwards; }
//         @keyframes confetti-burst { 0%{ transform: translate(0,0) rotate(0deg) scale(1); opacity:1; } 80%{ transform: translate(var(--dx), var(--dy)) rotate(var(--rot)); opacity:.95; } 100%{ transform: translate(calc(var(--dx)*1.15), calc(var(--dy)*1.15)) rotate(calc(var(--rot)*1.2)) scale(.9); opacity:0; } }
//         .fx-bull { position:absolute; font-size:36px; filter: drop-shadow(0 6px 18px rgba(255,180,0,.45)); pointer-events:none; animation: bull-pop 800ms ease-out forwards; }
//         @keyframes bull-pop { 0%{ transform: translate(-50%,-50%) scale(.6); opacity:0; } 45%{ transform: translate(-50%,-50%) scale(1.08); opacity:1; } 100%{ transform: translate(-50%,-50%) scale(1); opacity:0; } }
//       `}</style>
//     </div>
//   );
// }

// src/onboarding/activation/prototype/ChartArrowFollowLesson.jsx (or your route)
import React from "react";
import ActivationFlow from "../ActivationFlow"; // <— new orchestrator

export default function ChartArrowFollowLesson() {
  return <ActivationFlow />;
}

